export const NUM_MIN_ALTERADO = 'NUM_MIN_ALTERADO'
export const NUM_MAX_ALTERADO = 'NUM_MAX_ALTERADO'